import styled from 'styled-components';

import { spaceL, spaceM, xdlColorDisabled, xdlColorText } from '@xingternal/tokens';

export const FilterListContainer = styled.div`
  padding: ${spaceL} 28px;
`;

type FilterListItemTextProps = {
  $selected?: boolean;
  $disabled?: boolean;
};

export const FilterListItemText = styled.label<FilterListItemTextProps>`
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: ${spaceM};
  padding-bottom: ${spaceM};
  font-size: ${spaceL};
  font-weight: ${({ $selected }) => ($selected ? 'bold' : 'normal')};
  color: ${({ $disabled }) => ($disabled ? xdlColorDisabled : xdlColorText)};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
`;
